import { gql } from '@apollo/client'

export const GET_USER_ACCOUNT = gql`
  query GetUserAccount {
    userAccount {
      id
      email
      sub
      emailVerified
      name
      picture
      firstName
      lastName
      fullName
      displayName
      careerStatus
      roles
      createdAt
      updatedAt
    }
  }
`
